module.exports = __webpack_public_path__ + "img/left.bf56ad95.png";